export default __webpack_public_path__ + "95ff742f5ca23633f2957e0536f2e988.png";